import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import FallbackBackgroundLogo from '../../../../assets/svg/White@1.5x.svg';
import { fontSize } from '../../../../styles/themes/vad/font';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';

const useStyles = () =>
  makeStyles(theme => {
    const customStyle = {
      wrapper: {
        position: 'relative',
        ...theme.shape.componentSpacing,
        '& .tabPanelContainer .richText': {
          marginBottom: theme.spacing(8),
        },
        '& .tabs-container .MuiTabs-indicator': {
          background: theme.mixins.DarkTurquoise(),
        },
        '& .descriptionEventWrapper': {
          '& .MuiGrid-root': {
            ...theme.mixins.marginLR(0, 0),
          },
        },
        '& .MuiTabs-root': {
          marginTop: theme.spacing(4),
          marginBottom: theme.spacing(4),
        },
        '& .restaurant-offers-new': {
          '& h3': {
            ...theme.typography.h4,
            ...theme.mixins.marginLeft(0),
            textTransform: 'capitalize',
          },
        },
        '& .richText': {
          '& h2': {
            ...theme.typography.h4,
            ...theme.mixins.marginLeft(0),
            textTransform: 'capitalize',
          },
          '& .tableschdule': {
            '& .col-xl-9': {
              width: '100%',
            },
            width: '100%',
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(6),
            [theme.breakpoints.up('lg')]: {
              marginTop: '0',
              marginBottom: theme.spacing(11),
            },
          },
          '& .table-responsive': {
            minHeight: '0.01%',
            overflowX: 'auto',
            width: '100%',
            border: theme.borders.divider,
            overflowY: 'hidden',
          },
          '& table': {
            margin: '0',
            borderCollapse: 'collapse',
            boxShadow: theme.shadows[4],
            borderSpacing: 0,
            maxWidth: '100%',
            width: '100%',
            '& thead': {
              backgroundColor: theme.palette.background.default,
              [theme.breakpoints.down('md')]: {
                border: 'none',
              },
            },
            '& th': {
              ...theme.typography.body1,
              fontWeight: 'normal',
              textTransform: 'capitalize',
              textAlign: theme.mixins.textLeft(),
              paddingTop: pxToRem(11),
              paddingBottom: pxToRem(11),
              ...theme.mixins.paddingLeft(0, pxToRem(10)),
              [theme.breakpoints.down('sm')]: {
                whiteSpace: 'nowrap',
              },
              '&:first-child': {
                ...theme.mixins.paddingLeft(pxToRem(16)),
              },
              '&:last-child': {
                ...theme.mixins.paddingRight(pxToRem(16)),
              },
              [theme.breakpoints.up('lg')]: {
                paddingTop: pxToRem(30),
                paddingBottom: pxToRem(30),
                '&:first-child': {
                  ...theme.mixins.paddingLeft(pxToRem(50)),
                },
                '&:last-child': {
                  ...theme.mixins.paddingRight(pxToRem(50)),
                },
              },
              [theme.breakpoints.down('md')]: {
                ...theme.mixins.paddingLR(0, pxToRem(16)),
              },
            },
            '& td': {
              textAlign: theme.mixins.textLeft(),
              [theme.breakpoints.down('md')]: {
                ...theme.mixins.paddingLR(0, pxToRem(16)),
                padding: `${pxToRem(15)} 0`,
                '&:first-child': {
                  ...theme.mixins.paddingLeft(theme.spacing(2), pxToRem(10)),
                },
              },
              [theme.breakpoints.down('sm')]: {
                whiteSpace: 'nowrap',
              },
              '&._ec_three': {
                textAlign: 'center',
              },
              [theme.breakpoints.up('lg')]: {
                padding: `${pxToRem(40)} 0`,
              },
              '& p': {
                ...theme.typography.body1Bold,
                margin: 0,
              },
              '&:first-child': {
                [theme.breakpoints.down('md')]: {
                  ...theme.typography.body2Bold,
                },
                [theme.breakpoints.up('lg')]: {
                  ...theme.mixins.paddingLeft(pxToRem(50)),
                },
              },
              '& a': {
                textDecoration: 'none',
                position: 'relative',
                ...theme.typography.body2Bold,

                textTransform: 'capitalize',
                color: theme.mixins.White(),
                backgroundColor: '#ef5157',
                borderRadius: borderRadius.b28Rem,
                ...theme.mixins.paddingLR(pxToRem(24), pxToRem(52)),
                paddingTop: pxToRem(12),
                paddingBottom: pxToRem(12),
                [theme.breakpoints.up('lg')]: {
                  fontSize: fontSize.s16px,
                },
                '&::after': {
                  content:
                    "url(\"data:image/svg+xml;charset=UTF-8, <svg xmlns='http://www.w3.org/2000/svg' version='1.1' height='20' width='20' viewBox='0 0 20 20' fill='white'><path d='M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z'></path></svg>\")",
                  width: '20px',
                  height: '20px',
                  position: 'absolute',
                  top: 'calc(50% - 12px)',
                  ...theme.mixins.right(pxToRem(22)),
                },
              },
            },
            '& tbody': {
              '& tr': {
                borderTop: theme.borders.divider,
                '&:hover': {
                  backgroundColor: theme.palette.background.default,
                },
                [theme.breakpoints.down('md')]: {
                  borderTop: theme.borders.divider,
                },
              },
            },
          },
        },

        '& ._evnt_partner_cm_wd_': {
          marginBottom: theme.spacing(-4),
          '& ._event_part_card,.container, ._evnt_type_mode': {
            // ...theme.typography.h4,
            ...theme.mixins.marginLeft(0),
          },
          '& .partnereventwrap': {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            marginBottom: theme.spacing(4),
            '& h2, .partnerevent': {
              ...theme.typography.body2Bold,
              margin: 0,
              marginBottom: theme.spacing(2),
            },
            '& .ade-partners': {
              display: 'flex',
              justifyContent: 'center',
              flexWrap: 'wrap',
              '& img': {
                padding: theme.spacing(1),
                maxWidth: '104px',
                [theme.breakpoints.up('lg')]: {
                  maxWidth: '165px',
                },
              },
            },
          },
        },

        '& .hotel-offers, .raffle-draws': {
          '& .row': {
            display: 'flex',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            ...theme.mixins.marginRight(theme.spacing(-2)),
            [theme.breakpoints.up('lg')]: {
              flexWrap: 'wrap',
              marginBottom: pxToRem(-88),
            },
            '& .col-xl-3': {
              minWidth: '72%',
              ...theme.mixins.marginRight(theme.spacing(2)),
              '&>div': {
                height: '100%',
                '&>div': {
                  height: '100%',
                  '&>a': {
                    // flexGrow: 1,
                    overflow: 'hidden',
                  },
                },
              },
              [theme.breakpoints.up('lg')]: {
                width: 'calc((100% - 48px)/3)',
                minWidth: 'calc((100% - 48px)/3)',
                marginBottom: pxToRem(88),
              },
            },
            '& ._event_card_1, .umbrella_event': {
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: theme.mixins.Black(30),
              '& a': {
                maxHeight: pxToRem(235),
                '& img': {
                  width: '100%',
                  minWidth: '100%',
                  minHeight: pxToRem(150),
                  backgroundColor: '#dfe5e8',
                  backgroundImage: `url(${FallbackBackgroundLogo})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50%',
                  backgroundSize: '20%',

                  [theme.breakpoints.up('lg')]: {
                    minHeight: pxToRem(235),
                  },
                },
                '& :not(.img-to-animate-wrapper) img, & .img-to-animate-wrapper': {
                  transition: 'all 1s ease',
                },
              },
              '&:hover': {
                boxShadow: theme.shadows[1],
                backgroundColor: theme.mixins.White(),
                '& h3': {
                  color: theme.palette.common.SeaPort,
                },
                '& :not(.img-to-animate-wrapper) img, & .img-to-animate-wrapper': {
                  transform: 'scale(1.1, 1.1)',
                },
              },
            },
            '& .hotel_ec': {
              display: 'flex',
              flexDirection: 'column',
              padding: theme.spacing(3),
              '& ._ec_star_loc': {
                ...theme.typography.labelBold,
                textDecoration: 'none',
                marginBottom: theme.spacing(1),
              },
              '& ._ec_plce_hotl, .ec_discnt_auch': {
                ...theme.typography.cardTitle2,
                textDecoration: 'none',
                marginBottom: theme.spacing(1),
              },
              '& ._ec_htl_amnt': {
                ...theme.typography.labelBold,
                color: theme.palette.text.tertiary,
                marginBottom: theme.spacing(1),
              },
            },
          },
        },

        '& .Restorentnew-mob': {
          display: 'flex',
          flexWrap: 'nowrap',
          overflowX: 'auto',
          ...theme.mixins.marginRight(theme.spacing(-2)),
          [theme.breakpoints.up('lg')]: {
            flexWrap: 'wrap',
            marginBottom: pxToRem(-88),
          },
          '& .col-xl-3': {
            minWidth: '72%',
            ...theme.mixins.marginRight(theme.spacing(2)),
            '&>div': {
              height: '100%',
              '&>div': {
                height: '100%',
                '&>a': {
                  //flexGrow: 1,
                  overflow: 'hidden',
                  //marginBottom: pxToRem(25),
                },
              },
            },
            [theme.breakpoints.up('lg')]: {
              width: 'calc((100% - 48px)/3)',
              minWidth: 'calc((100% - 48px)/3)',
              marginBottom: pxToRem(88),
            },
          },
          '& ._event_card_1, .umbrella_event': {
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: theme.mixins.Black(30),
            '& ._event_card_disc, .rest_ec': {
              padding: theme.spacing(3),
            },
            '& a': {
              maxHeight: pxToRem(246),
              '& img': {
                width: '100%',
                minWidth: '100%',
                minHeight: pxToRem(246),
                backgroundColor: '#dfe5e8',
                backgroundImage: `url(${FallbackBackgroundLogo})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '50%',
                backgroundSize: '20%',
              },
              '& :not(.img-to-animate-wrapper) img, & .img-to-animate-wrapper': {
                transition: 'all 1s ease',
              },
            },
            '& p': {
              ...theme.typography.body3,
              color: theme.palette.text.tertiary,
              margin: 0,
              ...theme.palette.common.ellipsis(4),
              [theme.breakpoints.up('lg')]: {
                textOverflow: 'ellipsis',
                maxHeight: 'calc(1rem * 2.1 * 4)',
              },
            },
            '& ._ec_star_loc': {
              ...theme.typography.cardTitle2,
              textDecoration: 'none',
            },
            '& .ec_discnt_auch': {
              ...theme.typography.body3,
              color: theme.palette.text.tertiary,
              lineHeight: `${fontSize.s20Rem} !important`,
              marginBottom: pxToRem(8),
              marginTop: pxToRem(8),
            },
            '& ul': {
              margin: 0,
              padding: 0,
              marginBottom: pxToRem(4),
              ...theme.mixins.paddingLeft(pxToRem(16)),
              '&>li': {
                ...theme.typography.labelBold,
                lineHeight: fontSize.s24Rem,
                '&>a': {
                  ...theme.typography.body3,
                  color: theme.palette.text.secondary,
                  ...theme.mixins.marginLeft(pxToRem(-16)),
                },
              },
            },
            '&:hover': {
              boxShadow: theme.shadows[1],
              backgroundColor: theme.mixins.White(),
              '& h3': {
                color: theme.palette.common.SeaPort,
              },
              '& :not(.img-to-animate-wrapper) img, & .img-to-animate-wrapper': {
                transform: 'scale(1.1, 1.1)',
              },
            },
          },
        },
      },
    };
    return customStyle;
  })();

export default useStyles;
